const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '500px',
  },
  titleDiv: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '8px',
  },
  title: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%',
    margin: 0,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  radioOption: {
    margin: 0,
    '& .MuiFormControlLabel-label': {
      width: '100%',
    },
  },
  optionContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  optionLabel: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  inputContainer: {
    marginLeft: '40px',
    marginBottom: '16px',
  },
  noBoards: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    margin: 0,
  },
  selectBox: {
    '& .MuiOutlinedInput-input': {
      padding: '8.5px 14px',
    },
  },
  selectMenu: {
    maxHeight: '90vh',
  },
  loadingText: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  errorContainer: {
    marginTop: '12px',
    padding: '8px 12px',
    backgroundColor: '#FEE',
    borderRadius: '4px',
    border: '1px solid #FCC',
  },
  errorText: {
    color: '#C33',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    margin: 0,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    paddingTop: '12px',
  },
  cancelButton: {
    color: 'var(--mcg-dark, #002E47)',
    borderColor: 'var(--mcg-gray, #919EAB)',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '8px 0',
    position: 'sticky',
    bottom: 0,
    backgroundColor: '#fff',
  },
})

export default styles
